import { FareCode } from "@silversea-ssc/web-fares";
import React from "react";
import { CruisePriceAndOffersV2Response } from "src/ssc-api/prices/useCruisePrice";
import {
  FareCardHeaderProps,
  PromoBadgeContent,
  UnbundlingFareCardBase,
  UnbundlingFareCardContent,
  UnbundlingFareCardHeader
} from "@silversea-ssc/ui-components-react";
import { CruiseGroupCode } from "@silversea-ssc/web-cruise-groups";
import { isPresent } from "src/utils/checks";
import UnbundlingFareCardInfographic from "../FareCard/UnbundlingFareCardInfographic";

type CruiseFareCardProps = {
  title: string | undefined;
  fareCode: FareCode;
  cruiseGroup: CruiseGroupCode | undefined;
  cruisePrices: CruisePriceAndOffersV2Response;
  activePromos: PromoBadgeContent[];
  onPromoBadgeClicked?: FareCardHeaderProps["onPromoBadgeClicked"];
};

const UnbundlingCruiseFareCard: React.FC<CruiseFareCardProps> = ({
  title,
  fareCode,
  cruiseGroup,
  cruisePrices,
  activePromos,
  onPromoBadgeClicked
}) => {
  const fareInfo = cruisePrices.fares.find((f) => f.fare == fareCode);
  if (!isPresent(fareInfo)) return null;

  const { inclusionItems } = fareInfo;

  return (
    <UnbundlingFareCardBase trackingName={`infographic_${fareCode}`}>
      <UnbundlingFareCardHeader
        title={title || ""}
        withPromos
        promos={activePromos}
        onPromoBadgeClicked={onPromoBadgeClicked}
      />
      <UnbundlingFareCardContent>
        <UnbundlingFareCardInfographic
          cruiseGroup={cruiseGroup}
          enabledInclusions={inclusionItems.map((x) => x.code)}
          fareCode={fareCode}
          inclusionsContentTokens={cruisePrices.tokens}
        />
      </UnbundlingFareCardContent>
    </UnbundlingFareCardBase>
  );
};

export default UnbundlingCruiseFareCard;
